@if (initialized) {
  @if (isMenu) {
    <forge-menu [options]="chatMenuItems" [highlightFirst]="false"
      (forge-menu-select)="openChat($event)" (forge-menu-open)="menuOpened($event)">
      <forge-icon-button aria-label="Support chat">
        <forge-tooltip placement="bottom">
          Support chat
        </forge-tooltip>
        <forge-icon name="chat" aria-hidden="true" style="--forge-icon-color: var(--_app-bar-foreground);">
        </forge-icon>
      </forge-icon-button>
    </forge-menu>
  } @else {
    <forge-icon-button (click)="openChat($event)" tabindex="0" aria-label="Support chat">
      <forge-tooltip placement="bottom">
        {{singleChatText}}
      </forge-tooltip>
      <forge-icon name="chat" aria-hidden="true" style="--forge-icon-color: var(--_app-bar-foreground);">
      </forge-icon>
    </forge-icon-button>
  }
}

